import { useSelector, TypedUseSelectorHook } from "react-redux";
import { RootState } from "src/stores/reducer";

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;